document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-scroll]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href');
      if (id && id.startsWith('#')) {
        const target = document.querySelector(id);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});
// KSK Storefront 2.0 navigation
(() => {
  const initKskNavigation = () => {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.getElementById('MobileMenu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('mobile-menu-open', !open);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initKskNavigation);
  else initKskNavigation();
})();


// KSK v2.1.0 launch interactions
(() => {
  const initLaunchPolish = () => {
    const backToTop = document.querySelector('[data-back-to-top]');
    if (backToTop) {
      const update = () => backToTop.classList.toggle('is-visible', window.scrollY > 500);
      window.addEventListener('scroll', update, { passive: true });
      update();
      backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }

    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.getElementById('MobileMenu');
    if (toggle && menu) {
      const closeMenu = () => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.body.classList.remove('mobile-menu-open');
      };
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLaunchPolish);
  else initLaunchPolish();
})();


// KSK v3.1.4 storefront asset protection helpers (immediate blocking is installed inline in <head>).
(() => {
  const protectedSelector = '.product-page img, .product-main-media img, .product-thumbnails img, .ksk-product-lightbox__image, .product-media img, .product-image-wrap img, [data-product-media] img, .product-gallery img';

  const secureProductImages = (root = document) => {
    root.querySelectorAll(protectedSelector).forEach((img) => {
      img.setAttribute('draggable', 'false');
      img.setAttribute('oncontextmenu', 'return false;');
      img.setAttribute('ondragstart', 'return false;');
    });
  };

  const initKskAssetProtection = () => {
    secureProductImages();

    // Product media is replaced dynamically when thumbnails/variants change.
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches?.(protectedSelector)) {
            node.setAttribute('draggable', 'false');
            node.setAttribute('oncontextmenu', 'return false;');
            node.setAttribute('ondragstart', 'return false;');
          }
          secureProductImages(node);
        });
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Harden links opened in a new tab against opener access.
    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', Array.from(rel).join(' '));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initKskAssetProtection);
  else initKskAssetProtection();
})();

// KSK v3.1.18 — desktop submenu portal for laptop 100% zoom.
// The visual submenu is mounted directly under <body> so hero/header stacking
// and overflow rules cannot clip the Shop menu after its first item.
(() => {
  const desktopQuery = '(min-width: 1151px) and (min-height: 501px)';
  let portal = null;
  let activeItem = null;
  let closeTimer = null;

  const isDesktop = () => window.matchMedia(desktopQuery).matches;
  const cancelClose = () => {
    if (closeTimer) window.clearTimeout(closeTimer);
    closeTimer = null;
  };

  const ensureStyle = () => {
    if (document.getElementById('ksk-dropdown-portal-style')) return;
    const style = document.createElement('style');
    style.id = 'ksk-dropdown-portal-style';
    style.textContent = [
      '.ksk-desktop-menu-portal{position:fixed;display:none;grid-template-columns:1fr;gap:2px;box-sizing:border-box;width:310px;max-width:calc(100vw - 24px);padding:10px;background:#fffaf4;border:1px solid rgba(141,102,55,.28);border-radius:12px;box-shadow:0 18px 42px rgba(64,42,24,.24);z-index:2147483000;overflow-x:hidden;overflow-y:auto;}',
      '.ksk-desktop-menu-portal.is-open{display:grid!important;}',
      '.ksk-desktop-menu-portal a{display:block!important;width:100%!important;box-sizing:border-box;padding:11px 14px!important;border-radius:8px;color:#31241d!important;text-decoration:none!important;text-align:left!important;white-space:nowrap!important;font-size:13px!important;font-weight:650!important;letter-spacing:.08em!important;text-transform:uppercase!important;line-height:1.25!important;}',
      '.ksk-desktop-menu-portal a:hover,.ksk-desktop-menu-portal a:focus-visible{background:rgba(196,154,94,.14)!important;color:#5b3138!important;outline:none!important;}',
      '@media(max-width:1150px),(max-height:500px){.ksk-desktop-menu-portal{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  };

  const ensurePortal = () => {
    if (portal) return portal;
    ensureStyle();
    portal = document.createElement('nav');
    portal.className = 'ksk-desktop-menu-portal';
    portal.setAttribute('aria-label', 'Shop submenu');
    portal.addEventListener('mouseenter', cancelClose);
    portal.addEventListener('mouseleave', () => scheduleClose());
    portal.addEventListener('focusin', cancelClose);
    portal.addEventListener('focusout', (event) => {
      const next = event.relatedTarget;
      if (!portal.contains(next) && !(activeItem && activeItem.contains(next))) scheduleClose();
    });
    document.body.appendChild(portal);
    return portal;
  };

  const positionPortal = () => {
    if (!portal || !activeItem || !isDesktop()) return;
    const anchor = activeItem.querySelector(':scope > a') || activeItem;
    const rect = anchor.getBoundingClientRect();
    const width = Math.min(310, window.innerWidth - 24);
    const left = Math.max(12, Math.min(rect.left, window.innerWidth - width - 12));
    const top = rect.bottom + 8;
    portal.style.width = width + 'px';
    portal.style.left = left + 'px';
    portal.style.top = top + 'px';
    portal.style.maxHeight = Math.max(160, window.innerHeight - top - 12) + 'px';
  };

  const closePortal = () => {
    cancelClose();
    if (portal) {
      portal.classList.remove('is-open');
      portal.setAttribute('aria-hidden', 'true');
    }
    activeItem = null;
  };

  function scheduleClose() {
    cancelClose();
    closeTimer = window.setTimeout(closePortal, 220);
  }

  const openPortal = (item) => {
    if (!isDesktop()) return;
    cancelClose();
    const source = item.querySelector(':scope > .main-nav-dropdown');
    if (!source) return;
    const menu = ensurePortal();
    if (activeItem !== item) menu.innerHTML = source.innerHTML;
    activeItem = item;
    menu.setAttribute('aria-label', ((item.querySelector(':scope > a') || {}).textContent || 'Shop').trim() + ' submenu');
    menu.setAttribute('aria-hidden', 'false');
    menu.classList.add('is-open');
    positionPortal();
  };

  const initKskDesktopMenuPortal = () => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    ensureStyle();

    header.querySelectorAll('.main-nav-item.has-children').forEach((item) => {
      const source = item.querySelector(':scope > .main-nav-dropdown');
      if (!source) return;
      // Inline !important wins over the older hover rule in header.liquid.
      source.style.setProperty('display', 'none', 'important');
      source.setAttribute('aria-hidden', 'true');

      item.addEventListener('mouseenter', () => openPortal(item));
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', () => openPortal(item));
      item.addEventListener('focusout', (event) => {
        const next = event.relatedTarget;
        if (!item.contains(next) && !(portal && portal.contains(next))) scheduleClose();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePortal();
    });
    window.addEventListener('resize', () => {
      if (!isDesktop()) closePortal();
      else positionPortal();
    });
    window.addEventListener('scroll', positionPortal, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initKskDesktopMenuPortal);
  else initKskDesktopMenuPortal();
})();
